import { styled } from "@mui/material/styles";
import { Box, IconButton, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { RefObject } from "react";

export const RootContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.default,
  width: "70vw",
  height: "85vh",
  borderRadius: "10px",
  position: "relative",
  overflow: "hidden",
  [theme.breakpoints.down("xl")]: {
    width: "85vw",
    height: "85vh",
  },
  [theme.breakpoints.down("md")]: {
    width: "100vw",
    height: "100vh",
    borderRadius: 0,
  },
}));

export const ModalHeaderContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: "16px 20px",
}));

export const HeaderLeft = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "12px",
}));

export const HeaderAIIcon = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "40px",
  height: "40px",
  borderRadius: "4px",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.textInput,
  fontWeight: 700,
  fontSize: "16px",
  flexShrink: 0,
}));

export const HeaderTextContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: 1.7,
}));

export const HeaderSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "12px",
  lineHeight: 1.3,
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.tertiary,
  "&:hover": {
    color: theme.palette.text.primary,
  },
}));

type MessagesContainerProps = {
  theme: Theme;
  blockUserInput: boolean;
  ref: RefObject<HTMLDivElement>;
  gap: string;
};

export const MessagesContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "blockUserInput",
})(({ blockUserInput }: MessagesContainerProps) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  overflowY: "scroll",
  pointerEvents: blockUserInput ? "none" : "auto",
  position: "relative",
  padding: "10px 20px",
  width: "100%",
  height: "100%",
  maxWidth: "800px",
  alignSelf: "center",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

export const WelcomeMessageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
  paddingLeft: "30px",
  paddingRight: "30px",
}));

export const WelcomeMessage = styled(Typography)(() => ({
  textAlign: "center",
  fontSize: "18px",
  userSelect: "none",
}));

export const LoadingHistoryContainer = styled(Typography)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 3,
}));

export const LoadingHistoryMessage = styled(Typography)(() => ({
  fontSize: "14px",
  userSelect: "none",
}));

export const SessionTerminatedMessageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "20px",
  paddingBottom: "20px",
  width: "100%",
}));

export const SessionTerminatedMessage = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  color: theme.palette.grey.A400,
}));

export const InputFooterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: "12px 20px",
  backgroundColor: theme.palette.background.default,
}));

export const DisclaimerText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "11px",
  lineHeight: 1.4,
  padding: "10px 0 0 0",
  marginLeft: "50px",
}));
